export const GOOGLE_API_KEY = "AIzaSyAGW4_y5o03y6tGDdjiKaAvOmCbRsbTu8w";

export const TTS_ENDPOINT = "https://texttospeech.googleapis.com/v1";
export const TRANSLATE_ENDPOINT =
  "https://translation.googleapis.com/language/translate/v2";
